import $ from 'jquery';
import { FireComponent } from '@base';

export class Directory extends FireComponent {
  constructor(id) {
    super(id);
  }

  get elements() {
    return {
      $form: this.$component.find('[data-drupal-selector="views-exposed-form-directory-list"]'),
      $formUnitSelect: this.$component.find('[data-drupal-selector="edit-field-unit-target-id"]'),
      $formSearchInput: this.$component.find('[data-drupal-selector="edit-search"]'),
      $formLastNameLetterInput: this.$component.find('[data-drupal-selector="edit-field-last-name-value"]'),
      $filtersToggle: this.$component.find('[data-filters-toggle]'),
      $filters: this.$component.find('[data-filters]'),
      $filterUnit: this.$component.find('[data-filter-unit]'),
      $filterSearch: this.$component.find('[data-filter-search]'),
      $filterSearchBtn: this.$component.find('[data-filter-search-btn]'),
      $filterLetters: this.$component.find('[data-filter-letter]'),
      $clearFiltersBtn: this.$component.find('[data-filter-clear]'),
    };
  }

  _initUnitSelect() {
    if (this.elements.$formUnitSelect.length) {
      const options = this.elements.$formUnitSelect.get(0).children;
      [...options].map((option) => {
        this.elements.$filterUnit.get(0).innerHTML =
          this.elements.$filterUnit.get(0).innerHTML + `<option value="${option.value}">${option.innerText === '- Any -' ? 'All' : option.innerText}</option>`;
      });
    }
  }

  _filterByLetter() {
    if (this.elements.$filterLetters.length) {
      [...this.elements.$filterLetters].map((letter) => {
        const alpha = letter.dataset.filterLetter;
        const self = this;

        letter.addEventListener('click', function () {
          const currentSelected = self.$component.find('.bux-directory__letter--active');
          if (currentSelected.length) {
            currentSelected.get(0).classList.remove('bux-directory__letter--active');
            currentSelected.get(0).setAttribute('aria-current', 'false');
          }
          letter.classList.add('bux-directory__letter--active');
          letter.setAttribute('aria-current', 'true');

          if (alpha === 'All') {
            self.elements.$formLastNameLetterInput.get(0).value = '';
          } else {
            self.elements.$formLastNameLetterInput.get(0).value = alpha;
          }
          self._submitForm();
        });
      });
    }
  }

  _filterBySearch() {
    if (this.elements.$filterSearch.length && this.elements.$filterSearchBtn.length) {
      const self = this;
      this.elements.$filterSearchBtn.get(0).addEventListener('click', function () {
        const searchValue = self.elements.$filterSearch.get(0).value;
        self.elements.$formSearchInput.get(0).value = searchValue;
        self._submitForm();
      });
    }
  }

  _filterByUnit() {
    if (this.elements.$filterUnit.length) {
      const self = this;
      this.elements.$filterUnit.get(0).addEventListener('change', function () {
        const unitValue = self.elements.$filterUnit.get(0).value;
        self.elements.$formUnitSelect.get(0).value = unitValue;
        self._submitForm();
      });
    }
  }

  _isFiltered() {
    if (this.elements.$formLastNameLetterInput.get(0).value === '' && this.elements.$formSearchInput.get(0).value === '' && this.elements.$formUnitSelect.get(0).value === 'All') {
      this._showClearButton(false);
    } else {
      this._showClearButton(true);
    }
  }

  _showClearButton(show = true) {
    if (show) {
      this.elements.$clearFiltersBtn.get(0).classList.remove('hidden');
    } else {
      this.elements.$clearFiltersBtn.get(0).classList.add('hidden');
    }
  }

  _clearForm() {
    const self = this;
    this.elements.$clearFiltersBtn.get(0).addEventListener('click', function () {
      //create element for screen readers to announce filters were cleared
      //then remove after it's announced.
      let alert = document.createElement('div');
      alert.setAttribute('role', 'alert');
      alert.setAttribute('aria-live', 'polite');
      alert.classList.add('sr-only');
      self.$component.get(0).appendChild(alert);
      alert.innerText = 'Filter cleared successfully.';
      setTimeout(() => {
        alert.remove();
      }, 2000);

      const currentSelected = self.$component.find('.bux-directory__letter--active');
      currentSelected.get(0).classList.remove('bux-directory__letter--active');
      currentSelected.get(0).setAttribute('aria-current', 'false');
      const letterAll = self.$component.find('[data-filter-letter="All"]');
      letterAll.get(0).classList.add('bux-directory__letter--active');
      letterAll.get(0).setAttribute('aria-current', 'true');
      self.elements.$formLastNameLetterInput.get(0).value = '';

      self.elements.$filterSearch.get(0).value = '';
      self.elements.$formSearchInput.get(0).value = '';

      self.elements.$filterUnit.get(0).value = 'All';
      self.elements.$formUnitSelect.get(0).value = 'All';

      self._submitForm();
    });
  }

  _submitForm() {
    this._isFiltered();
    const submitButton = this.elements.$form.get(0).querySelector('input[type="submit"]');
    submitButton.click();
  }

  _toggleFilterView() {
    this.elements.$filtersToggle.get(0).setAttribute('aria-expanded', 'true');
    if (!window.matchMedia('(min-width: 960px').matches) {
      const self = this;
      this.elements.$filtersToggle.get(0).setAttribute('aria-expanded', 'false');
      this.elements.$filtersToggle.get(0).addEventListener('click', function () {
        if (self.elements.$filtersToggle.get(0).getAttribute('aria-expanded') === 'true') {
          self.elements.$filtersToggle.get(0).setAttribute('aria-expanded', 'false');
        } else {
          self.elements.$filtersToggle.get(0).setAttribute('aria-expanded', 'true');
        }
      });
    }
  }

  init() {
    if (this.componentExists) {
      this._initUnitSelect();
      this._filterByLetter();
      this._filterBySearch();
      this._filterByUnit();
      this._clearForm();
      this._toggleFilterView();

      var self = this;
      $(window).on('resize', function () {
        self._toggleFilterView();
      });
    }
  }
}
